import type { NormalizedError, ActionType } from '../constants/errorCodes';
import { clearError } from '../store/duckers/error/slice';

export const hasUsableAction = (action: NormalizedError['action']): boolean => {
  if (action.type === 'none') return false;
  if (action.type === 'call_business' && !action.payload?.phone) return false;
  return true;
};

type ActionContext = {
  dispatch: (action: any) => void;
  navigate: (path: string) => void;
  businessId: string | undefined;
  lastPhone: string | undefined;
  resendOtp: (phone: string) => void;
  /** Injectable location object — defaults to window.location (allows unit-test mocking) */
  location?: { href: string; reload: () => void };
};

export function runActionHandler(
  action: NormalizedError['action'],
  ctx: ActionContext,
): void {
  const loc = ctx.location ?? window.location;
  ctx.dispatch(clearError());

  switch (action.type as ActionType) {
    case 'retry':
      return;

    case 'resend_otp':
      if (ctx.lastPhone) ctx.resendOtp(ctx.lastPhone);
      return;

    case 'call_business': {
      const phone = (action.payload?.phone as string | undefined) ?? '';
      if (phone) loc.href = `tel:${phone}`;
      return;
    }

    case 'pick_other_slot':
      if (ctx.businessId) ctx.navigate(`/${ctx.businessId}/slots`);
      return;

    case 'refresh':
      loc.reload();
      return;

    case 'none':
      return;
  }
}
